/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Hungarian
export default {
  'fabric.elements.mentions.team.member.50plus': 'Csapat • 50+ tag',
  'fabric.elements.mentions.team.member.50plus.including.you': 'Csapat • 50+ tag veled együtt',
  'fabric.elements.mentions.team.member.count': '{0, plural, one {Csapat • 1 tag} other {Csapat • {0} tag}}',
  'fabric.elements.mentions.team.member.count.including.you': '{0, plural, one {Csapat • 1 tag veled együtt} other {Csapat • {0} tag veled együtt}}',
  'fabric.elements.mentions.xproduct.mention.description': 'Hozzáférésre van szüksége a Confluence-hez',
  'fabric.mention.error.defaultAction': 'Néhány másodperc múlva próbálja meg újból.',
  'fabric.mention.error.defaultHeadline': 'Hiba történt.',
  'fabric.mention.error.differentText': 'Próbáljon meg más szöveget beírni.',
  'fabric.mention.error.loginAgain': 'Próbáljon meg kijelentkezni, majd újból bejelentkezni.',
  'fabric.mention.noAccess.label': 'Nincs hozzáférés',
  'fabric.mention.noAccess.warning': '{name} nem kap értesítést, mert nincs hozzáférése.',
  'fabric.mention.unknow.user.error': 'Ismeretlen felhasználó: {userId}'
};